import axios from "axios";
const session_expired = `Session expired. Please log in again for continued access`;
export const axiosInstance = axios.create();
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    const language = localStorage.getItem("language");
    config.headers.Authorization = token;
    config.headers["Accept-Language"] = language;
    return config;
  },
  (error) => Promise.reject(error)
);
axiosInstance.interceptors.response.use((response) => {
  if (response.data?.statusCodeValue !== 401) {
    return response;
  } else if (response.data?.body?.error === session_expired) {
    // localStorage.clear()
    localStorage.removeItem("memberId");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("ref_token");
    window.location.href = "/";
  } else if (response?.data?.body?.error) {
    return response;
  }
});
